import { useEffect, useState } from 'react';
import { ButtonSecondary, ButtonSize, IconEdit, PermissionEnum } from '@ui/src';
import Card from '../../common/card/card';
import GeneralUserInfoBlock from './parts/general-user-info-block';
import GeneralUserInfoContacts from './parts/general-user-info-contacts';
import GeneralUserInfoProducts from './parts/genera-user-info-products';
import GeneralUserInfoRow from './parts/general-user-info-row';
import { CustomerStatus, OrganizationType } from '../../../hoc/common/types';
import { GeneralUserInfoTypes } from './types';

import cn from './styles.module.css';

const GeneralUserInfo = ({
  isLoading,
  generalUserInfo,
  control,
  onInfoSubmit,
  baseUserInformation,
  requestInProgress,
  isSuccess,
  recoveryInProgress,
  onResetPassword,
  globalError,
  errors,
  setConvertPopuVisible,
  convertToIndividualAvailable,
  status,
  activePermissions,
  sourcesOfFunds,
  clientsActivities,
  countries,
  productsIndividual,
}: GeneralUserInfoTypes) => {
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setEdit(false);
    }
  }, [isSuccess]);

  return (
    <Card title="General info" isLoading={isLoading}>
      <GeneralUserInfoBlock
        generalUserInfo={generalUserInfo}
        baseUserInformation={baseUserInformation}
        control={control}
        globalError={globalError}
        errors={errors}
        edit={edit}
        sourcesOfFunds={sourcesOfFunds}
        clientsActivities={clientsActivities}
        countries={countries}
      />
      {generalUserInfo?.type !== OrganizationType.COMPANY_OFFICIAL && (
        <GeneralUserInfoProducts
          baseUserInformation={baseUserInformation}
          control={control}
          edit={edit}
          productsIndividual={productsIndividual}
        />
      )}
      <GeneralUserInfoContacts
        baseUserInformation={baseUserInformation}
        control={control}
        recoveryInProgress={recoveryInProgress}
        onResetPassword={onResetPassword}
        edit={edit}
        activePermissions={activePermissions}
      />
      {baseUserInformation?.type === OrganizationType.COMPANY_OFFICIAL &&
        setConvertPopuVisible &&
        convertToIndividualAvailable && (
          <div className={cn.convertToIndividaul}>
            <div className={cn.generalUserInfoBlockItem}>
              <GeneralUserInfoRow title="Customer type" type="default">
                <ButtonSecondary
                  size={ButtonSize.SMALL}
                  className={`button-white ${cn.passwordButton}`}
                  text={
                    recoveryInProgress
                      ? 'Loading...'
                      : ' Convert to an individual customer'
                  }
                  onClick={() => setConvertPopuVisible(true)}
                />
              </GeneralUserInfoRow>
            </div>
          </div>
        )}
      {activePermissions?.includes(
        PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_DETAILS_ACTION,
      ) && (
        <div className={cn.generalUserInfoBlock}>
          <div className={cn.formControls}>
            {!edit && status !== CustomerStatus.CLOSED && (
              <ButtonSecondary
                size={ButtonSize.SMALL}
                className={`button-white ${cn.activeEditButton}`}
                text="Edit"
                icon={<IconEdit />}
                onClick={() => setEdit(true)}
              />
            )}
            {edit && (
              <>
                <ButtonSecondary
                  size={ButtonSize.SMALL}
                  text={requestInProgress ? 'Loading...' : 'Save'}
                  className={cn.saveButton}
                  onClick={onInfoSubmit}
                />
                <ButtonSecondary
                  size={ButtonSize.SMALL}
                  className={`button-white ${cn.activeEditButton}`}
                  text="Cancel"
                  onClick={() => setEdit(false)}
                />
              </>
            )}
          </div>
        </div>
      )}
    </Card>
  );
};

export default GeneralUserInfo;
